export default `
/* 公共样式 */

// g-placeholder组件样式
.load_box {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

// 隐藏滚动条
.hide_scrollBar {
  &::-webkit-scrollbar,
  .el-table__body-wrapper::-webkit-scrollbar {
    display: none;
  }
  &::-webkit-scrollbar-thumb,
  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    display: none;
  }
}

// 分页器
.pagination {
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li,
  .el-input__inner {
    background: transparent;
  }
  .el-pagination.is-background .el-pager li {
    background: none;
    border-radius: var(--lego-theme-public-filter-css-border-radius, 4px);
  }
  .el-input__inner {
    color: var(--notification-font-color);
    border: 1px solid var(--lego-theme-filter-border-color);
    width: 40px;
    height: 24px;
    background-color: transparent;
    border-radius: var(--lego-theme-public-filter-css-border-radius, 4px);
  }
  .el-pagination__jump,
  .el-pagination__total,
  .el-pagination.is-background .el-pager li,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .btn-next {
    color: var(--notification-font-color);
  }
  .el-pagination.is-background .el-pager li:hover,
  .el-pagination.is-background .btn-prev:hover,
  .el-pagination.is-background .btn-next:hover {
    background: hsla(0, 0%, 60%, 0.15);
    color: var(--notification-font-color);
  }
  .el-pagination .el-pager li {
    border-radius: var(--lego-theme-public-filter-css-border-radius, 4px);
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: var(--notification-theme-color);
  }
}

// 日历组件
.el-calendar {
  background-color: #fff;
}

.el-calendar__header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: 1px solid #ebeef5;
}

.el-calendar__title {
  color: #000;
  -ms-flex-item-align: center;
  align-self: center;
}

.el-calendar__body {
  padding: 12px 20px 35px;
}

.el-calendar-table {
  table-layout: fixed;
  width: 100%;
}

.el-calendar-table thead th {
  padding: 12px 0;
  color: #606266;
  font-weight: 400;
}

.el-calendar-table:not(.is-range) td.next,
.el-calendar-table:not(.is-range) td.prev {
  color: #c0c4cc;
}

.el-calendar-table td {
  border-bottom: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
  vertical-align: top;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.el-calendar-table td.is-selected {
  background-color: #f2f8fe;
}

.el-calendar-table td.is-today {
  color: #409eff;
}

.el-calendar-table tr:first-child td {
  border-top: 1px solid #ebeef5;
}

.el-calendar-table tr td:first-child {
  border-left: 1px solid #ebeef5;
}

.el-calendar-table tr.el-calendar-table__row--hide-border td {
  border-top: none;
}

.el-calendar-table .el-calendar-day {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 8px;
  height: 85px;
}

.el-calendar-table .el-calendar-day:hover {
  cursor: pointer;
  background-color: #f2f8fe;
}


// tooltip组件样式
.tooltip_dark {
  background: rgba(0,0,0,.6)!important;
  .tooltip_checkOption {
    max-height: 450px;
    display: flex;
    flex-wrap: wrap;
    overflow-y: scroll;
    >li {
      height: 22px;
      display: flex;
      align-items: center;
      font-size: 12px;
      margin-right: 5px;
      margin-bottom: 10px;
      padding-left: 8px;
      box-sizing: border-box;
      border-radius: 2px;
      border: 1px solid var(--notification-font-color);
      .text {
          white-space: nowrap;
      }
      .close_icon {
          width: 25px;
          display: flex;
          align-items: center;
          justify-content: center;
      }
    }
  }
}

`


// WEBPACK FOOTER //
// ./src/pages/frontProJect/code/css.js